export default {
  'java': 'Java',
  'python': 'Python',
  'c_cpp': 'C++'
};